import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ArrowRightOutlined from '@ant-design/icons/ArrowRightOutlined';
import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';

import CallHistory from 'src/components/ui/CallHistory';

import { DIRECTION } from './constants';

const ReasonView = (props) => {
	const {
		label,
		date,
		from,
		to,
		direction = 'direct',
		suffix,
		textOnly,
		call,
		iconColor,
	} = props;

	if (textOnly) {
		return <Typography>{textOnly}</Typography>;
	}

	const result = (
		<Stack direction="row" gap={1}>
			{label && (
				<Typography sx={{ width: 76 }} variant="body1">
					{label}
				</Typography>
			)}
			{date && <Typography variant="body1">{date}</Typography>}
			{from && <Typography variant="body1">{from}</Typography>}
			{suffix && <Typography color="text.secondary">{suffix}</Typography>}
			{!suffix && (
				<Box color="text.secondary">
					{direction === DIRECTION.direct ? (
						<ArrowRightOutlined style={{ color: iconColor }} />
					) : (
						<ArrowLeftOutlined style={{ color: iconColor }} />
					)}
				</Box>
			)}
			{to && <Typography variant="body1">{to}</Typography>}
		</Stack>
	);

	if (call) {
		return <CallHistory topContent={result} {...call} />;
	}

	return result;
};

ReasonView.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	label: PropTypes.string,
	date: PropTypes.string,
	from: PropTypes.string,
	to: PropTypes.string,
	suffix: PropTypes.string,
	textOnly: PropTypes.string,
	iconColor: PropTypes.string, // css color
	direction: PropTypes.oneOf(Object.values(DIRECTION)),
	call: PropTypes.shape(CallHistory.propTypes),
};

export default ReasonView;
